export default {
  data() {
    return {
      breadcrumb: [
        { label: 'Quản lí teams', path: '/teams' }
      ],
      checkedlist: [],
      filter: {
        q: '',
        per_page: 20,
        page: 1
      },
      result: null,
      lockedMessage: '',
      crudForm: this.defaultCrudForm(),
      isSearching: false
    }
  },

  computed: {
    master() {
      return this.$store.state.master;
    }
  },

  methods: {
    checkall() {
      if (this.checkedlist.length == this.result.data.length) this.checkedlist = [];
      else this.checkedlist = this.result.data.map((item) => item.id);
    },

    toggleCheckbox(id) {
      if (this.checkedlist.includes(id)) this.checkedlist.splice(this.checkedlist.indexOf(id), 1);
      else this.checkedlist.push(id);
    },

    defaultCrudForm() {
      return {
        id: 0,
        name: '',
        code: '',
        errors: {}
      };
    },

    async search() {
      this.checkedlist = [];
      this.isSearching = true;
      let res = await this.$api.team.search(this.filter).call();
      this.isSearching = false;

      if (res.success) {
        this.result = res.response.result;
      }
    },

    openModalCreate() {
      this.crudForm = this.defaultCrudForm();
      this.$refs.crudModal.show();
    },

    openModalUpdate(data) {
      this.crudForm = this.defaultCrudForm();
      this.crudForm.id = data.id;
      this.crudForm.name = data.name;
      this.crudForm.code = data.code;
      this.$refs.crudModal.show();
    },

    async onSaveCrud(){
      let req;
      let data = {...this.crudForm };
      delete data.errors;

      if (data.id) req = this.$api.team.update(data);
      else req = this.$api.team.create(data);
      let res = await req.call();

      if (res.success) {
        this.search();
        this.$refs.crudModal.hide();
      } else {
        if (res?.response?.result?.errors) this.crudForm.errors = res.response.result.errors;
      }
    },

    onChangePage(page){
      this.filter.page = page;
      this.search();
    },

    async onDelete() {
      this.$store.dispatch("confirmation/open", {
        title: "Xác nhận",
        type: 'confirmation',
        message: "Bạn thực sự muốn xóa "+this.checkedlist.length+" teams được chọn?",
        options: [
          {
            name: "cancel",
            label: "Hủy",
            variant: "secondary",
          },
          {
            name: "delete",
            label: "Xóa",
            variant: "danger"
          },
        ],
        events: {
          confirm: async (name) => {
            if (name == 'delete') {
              let res = await this.$api.team.delete({id: this.checkedlist}).call();

              if (res.success) {
                this.checkedlist = [];
                this.search();
              }
            }
          }
        }
      });
    },
  },

  mounted() {
    this.search();
  }
}